import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCsvCommisionByFinancial } from './CommissionByFinancial.service';

export function useCommisionByFinancialCsv() {
  return useMutation(getQuestReportCsvCommisionByFinancial, {
    onSuccess() {
      notification.success({
        message:
          'O relatório Commissão por Movimentação foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
